<template>
  <Transition name="fade">
    <DesignwishPopup v-if="designWishOpen"/>
  </Transition>
  <Transition name="fade">
    <DeliverytimePopup v-if="deliverTimeOpen"/>
  </Transition>
  <Transition name="fade">
    <ShareDraftPopup v-if="socialShareOpen"/>
  </Transition>
  <Transition name="fade">
    <RdyDesignPopup v-if=" rdyDesignOpen"/>
  </Transition>
  <Transition name="fade">
    <FarbvorschlagPopup v-if="farbvorschlagOpen"/>
  </Transition>
  <Transition name="fade">
    <DesigncheckPopup v-if="designCheckOpen"/>
  </Transition>
  <Transition name="fade">
    <ContactFormPopup v-if="contactFormOpen"/>
  </Transition>
  <Transition name="fade">
    <ContactPopup v-if="contactOpen"/>
  </Transition>
  <Transition name="fade">
    <ProductSizePopup v-if="productSizeOpen"/>
  </Transition>
  <Transition name="fade">
    <ExpressAnfrage v-if="expressanfrageOpen"/>
  </Transition>
  <Transition name="fade">
    <LieferzeitAnfrage v-if="lieferzeitAnfrageIsOpen"/>
  </Transition>
</template>

<script lang="ts" setup>
import ProductSizePopup from "@km/components/popups/ProductSizePopup.vue";
import ContactPopup from "@km/components/popups/ContactPopup.vue";
import ContactFormPopup from "@km/components/popups/ContactFormPopup.vue"
import DesigncheckPopup from "@km/components/popups/DesigncheckPopup.vue";
import ShareDraftPopup from "@km/components/popups/ShareDraftPopup.vue";
import RdyDesignPopup from "@km/components/popups/RdyDesign.vue";
import FarbvorschlagPopup from "@km/components/popups/ColorVorschlag.vue";
import {useStore} from "vuex";
import {computed, defineAsyncComponent} from "vue";
import ExpressAnfrage from "@km/components/popups/ExpressAnfrage.vue";
import LieferzeitAnfrage from "@km/components/popups/LieferzeitAnfrage.vue";

const DesignwishPopup = defineAsyncComponent(()=>import("@km/components/popups/DesignwishPopup.vue"));
const DeliverytimePopup = defineAsyncComponent(()=>import("@km/components/popups/DeliverytimePopup.vue"));
const store = useStore();

const designCheckOpen = computed(() => store.getters.designcheckoverlayIsOpen);
const designWishOpen = computed(() => store.getters.designwishoverlayIsOpen);
const deliverTimeOpen = computed(() => store.getters.deliverytimeoverlayIsOpen);
const contactOpen = computed(() => store.getters.contactoverlayIsOpen);
const contactFormOpen = computed(() => store.getters.contactformoverlayIsOpen);
const socialShareOpen = computed(() => store.getters.socialshareoverlayIsOpen);
const rdyDesignOpen = computed(() => store.getters.rdydesignoverlayIsOpen);
const farbvorschlagOpen = computed(() => store.getters.farbvorschlagoverlayIsOpen);
const productSizeOpen = computed(() => store.getters.productsizeIsOpen);
const expressanfrageOpen = computed(() => store.getters.expressanfrageOverlayIsOpen);
const lieferzeitAnfrageIsOpen = computed(() => store.getters.lieferzeitAnfrageIsOpen);

</script>

<style scoped lang="scss">
@import "../../scss/transitions.scss";

@include fadeTransition;
</style>
